import LegalPage, { type BusinessIdentity } from '../../components/LegalPage'

interface Props {
  business: BusinessIdentity
}

// Full document text lives in config/locales under frontend.legal.privacy.
export default function Privacy({ business }: Props) {
  return <LegalPage page="privacy" business={business} />
}
